jQuery(document).ready(function($) {
    
    $(document).on('change', '[data-name="associated_author"] select', function() {
        
        var newAuthorId = $(this).val();
        var postId = $('#post_ID').val() || acf.get('post_id');
        
        if (!newAuthorId) {
            //console.log('No author selected');
            // Clear all post dropdowns when no author is selected
            clearPostDropdowns();
            return;
        }
        
        //console.log('Author changed to:', newAuthorId);
        
        // Custom AJAX to get filtered posts
        $.ajax({
            url: acf_ajax.ajaxurl,
            type: 'POST',
            data: {
                action: 'get_filtered_posts',
                author_id: newAuthorId,
                post_id: postId,
                nonce: acf_ajax.nonce
            },
            success: function(response) {
                //console.log('Got response:', response);
                
                if (response.success && response.data.results) {
                    updatePostDropdowns(response.data.results);
                } else {
                    console.error('AJAX request failed:', response);
                    clearPostDropdowns();
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error:', error);
                clearPostDropdowns();
            }
        });
    });
    
    function updatePostDropdowns(posts) {
        // Update each post field in the repeater
        $('.acf-field[data-name="recommended_blog_posts"] .acf-row:not(.acf-clone)').each(function() {
            var $row = $(this);
            var $field = $row.find('.acf-field[data-name="post"]');
            var $select = $field.find('select');
            
            if ($select.length) {
                updateSingleSelect($select, posts);
            }
        });
    }
    
    function clearPostDropdowns() {
        $('.acf-field[data-name="recommended_blog_posts"] .acf-row:not(.acf-clone)').each(function() {
            var $row = $(this);
            var $field = $row.find('.acf-field[data-name="post"]');
            var $select = $field.find('select');
            
            if ($select.length) {
                updateSingleSelect($select, []);
            }
        });
    }
    
    function updateSingleSelect($select, posts) {
        // Store current value
        var currentValue = $select.val();
        
        // Completely destroy Select2 if it exists
        if ($select.hasClass('select2-hidden-accessible')) {
            $select.select2('destroy');
        }
        
        // Clear all options
        $select.empty();
        
        // Add default option
        $select.append('<option value="">- Select -</option>');
        
        // Add new options
        $.each(posts, function(i, item) {
            $select.append('<option value="' + item.id + '">' + item.text + '</option>');
        });
        
        // Get ACF's Select2 settings
        var select2Args = {
            allowNull: true,
            placeholder: "Select a post",
            multiple: false,
            width: '100%'
        };
        
        // Try to use ACF's Select2 settings if available
        if (typeof acf !== 'undefined' && acf.get_field) {
            var field = acf.get_field($select.closest('.acf-field'));
            if (field && field.get('select2')) {
                select2Args = $.extend(select2Args, field.get('select2'));
            }
        }
        
        // Reinitialize Select2
        $select.select2(select2Args);
        
        // Restore previous value if it still exists in the new options
        if (currentValue && $select.find('option[value="' + currentValue + '"]').length > 0) {
            $select.val(currentValue).trigger('change.select2');
        } else {
            // Clear the field since the previous selection is no longer valid
            $select.val('').trigger('change.select2');
        }
        
        // Trigger ACF change event to ensure ACF knows about the update
        $select.trigger('change');
    }
    
    // Handle new rows added to the repeater
    $(document).on('click', '.acf-field[data-name="recommended_blog_posts"] .acf-button[data-event="add-row"]', function() {
        // Small delay to let ACF create the new row
        setTimeout(function() {
            var authorId = $('[data-name="associated_author"] select').val();
            if (authorId) {
                // Trigger the author change to update the new row's dropdown
                $('[data-name="associated_author"] select').trigger('change');
            }
        }, 100);
    });
    
});